import { CHECK_STORE_STATUS, RoleEnum } from "@/types";

const ROLE_LABELS = {
  [RoleEnum.STORE_MANAGER]: "店長",
  [RoleEnum.USER]: "店員",
  [RoleEnum.COMPANY_ADMIN]: "事業者管理者",
  [RoleEnum.HEAD_OFFICE_USER]: "本部管理者",
  [RoleEnum.SUPER_ADMIN]: "スーパー管理者",
  [RoleEnum.OTHER]: "非会員",
};

const KEYS_SEARCH_PARAMS = {
  SEARCH: "search",
  PAGE: "page",
};

const DEFAULT_PAGE_SIZE = 14;

const CHECK_STORE_STATUS_LABEL = {
  [CHECK_STORE_STATUS.NOTIFIED]: "通知済",
  [CHECK_STORE_STATUS.DRAFT]: "下書き",
};

export {
  ROLE_LABELS,
  KEYS_SEARCH_PARAMS,
  DEFAULT_PAGE_SIZE,
  CHECK_STORE_STATUS_LABEL,
};
